import * as React from 'react';

function SvgProgressMakingPayment(props) {
  return (
    <svg width={18} height={18} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16.393.967H1.607a.642.642 0 00-.643.643v14.785c0 .356.287.643.643.643h14.786a.642.642 0 00.642-.643V1.61a.642.642 0 00-.642-.643zm-.804 9.321H9.321V7.717h6.268v2.571zm0 5.304H2.411V2.413h13.178v4.018H8.68a.642.642 0 00-.643.643v3.857c0 .356.287.643.642.643h6.911v4.018zm-5.223-6.59a.804.804 0 101.607 0 .804.804 0 00-1.607 0z" />
    </svg>
  );
}

export default SvgProgressMakingPayment;
